const PROCESSOR_FEE_RATE = Number(process.env.REACT_APP_PROCESSOR_FEE_RATE);
// const PLATFORM_FEE_RATE = Number(process.env.REACT_APP_PLATFORM_FEE_RATE);
// const COMBINED_RATE = PROCESSOR_FEE_RATE + PLATFORM_FEE_RATE;

export interface FeeBreakdown {
  grossAmount: number;
  amountChargedToPatron: number;
  coverFeeLine: number;
  processorFee: number;
  platformFee: number;
  netToOrg: number;
}

export function calculateFees(grossAmount: number, isCoverFee: boolean, platformDefaultFee: number): FeeBreakdown {
  const r = PROCESSOR_FEE_RATE + platformDefaultFee * 0.01;

  const amountChargedToPatron = isCoverFee ? grossAmount / (1 - r) : grossAmount;

  const coverFeeLine = amountChargedToPatron - grossAmount;
  const processorFee = amountChargedToPatron * PROCESSOR_FEE_RATE;
  const platformFee = amountChargedToPatron * (platformDefaultFee * 0.01);
  // const platformFee = amountChargedToPatron * PLATFORM_FEE_RATE;
  const netToOrg = amountChargedToPatron - processorFee - platformFee;

  return {
    grossAmount,
    amountChargedToPatron,
    coverFeeLine,
    processorFee,
    platformFee,
    netToOrg,
  };
}
